import MasterLayout from "@/components/layouts/MasterLayoutComponent.vue";
import {RouteConfig} from "vue-router";

const routes: Array<RouteConfig> = [
  {
    path: "/admin/learning_goals",
    name: "LearningGoalList",
    component: () => import("../views/LearningGoal/LearningGoalList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/learning_goals/add",
    name: "LearningGoalAdd",
    component: () => import("../views/LearningGoal/LearningGoalForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/learning_goals/:id/edit",
    name: "LearningGoalEdit",
    component: () => import("../views/LearningGoal/LearningGoalForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/learning_goals/:id/show",
    name: "LearningGoalShow",
    component: () => import("../views/LearningGoal/LearningGoalShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/learning_goal_quizzes",
    name: "LearningGoalQuizList",
    component: () => import("../views/LearningGoal/LearningGoalQuiz/LearningGoalQuizList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/learning_goal_quizzes/add",
    name: "LearningGoalQuizAdd",
    component: () => import("../views/LearningGoal/LearningGoalQuiz/LearningGoalQuizForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/learning_goal_quizzes/:id/edit",
    name: "LearningGoalQuizEdit",
    component: () => import("../views/LearningGoal/LearningGoalQuiz/LearningGoalQuizForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/learning_goal_quizzes/:id/show",
    name: "LearningGoalQuizShow",
    component: () => import("../views/LearningGoal/LearningGoalQuiz/LearningGoalQuizShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
];

export default routes;
